import { Component, OnInit } from '@angular/core';
import { DataService } from '@core/services';
import { APIClient } from '../modules/_services/api/@generated';
import { ToastService, LoadscreenService } from '@core/services';
import { Router } from '@angular/router';
import { faCreditCard, faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss'],
  standalone: false
})
export class PaymentCompleteComponent implements OnInit {

  constructor(public ToastService: ToastService, public LoadscreenService: LoadscreenService, private api: APIClient,
              public dataService: DataService, private router: Router, private translate: TranslateService) { }
  faCreditCard = faCreditCard;
  faTimesCircle = faTimesCircle;
  faCheckCircle = faCheckCircle;

  providerData: any;
  paymentCode: string;
  insuredPerson: any;

  paymentSuccessful: boolean;
  paymentProcessEnded = false;
  paymentTransactionCode: string;
  offerNumber: string;

  _contractorName: string;
  _linkType: string;

  public connectionLinkType: string = null;

  ngOnInit(): void {
    this.dataService.setLanguage(sessionStorage.getItem('selectedLanguage') || 'hu');
    this.translate.get('paymentComplete.pleaseWait').subscribe((val) => {
      this.LoadscreenService.initiateLoading(val);
    });
    this._contractorName = JSON.parse(sessionStorage.getItem('HIPContract'))?.contractorName;
    this._linkType = JSON.parse(sessionStorage.getItem('HIPInsuredPersonFromHIPDto'))?.linkType;
    this.connectionLinkType = sessionStorage.getItem('connectionLinkType');
    this.dataService.connectionLinkType = this.connectionLinkType;

    if (window.location.href.includes('localhost')) {
      this.providerData = 'F289A311-3600-4924-969B-8AA52193081A';
    } else {
      this.providerData = window.location.href.split('payment-complete?');
      this.providerData = this.providerData[1];
    }

    this.api.processPaymentResponse({providerData: this.providerData}).subscribe(response => {
      this.paymentCode = response.response;
      this.getInsuredPerson();
    }, error => {
      this.LoadscreenService.cancelLoading();
      this.ToastService.initializeMessage(error.message, 'error');
    });

    //SET this for testing porpuses
    //this.paymentCode = '95YYLMTRNKMB6BBYFD6M';
    //this.getInsuredPerson();
  }

  formatCurrency(price: any) {
    if(price == 'undefined') {
      return "-";
    }
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  getInsuredPerson() {
    this.api.getInsuredPersonFromHipQuery({paymentCode: this.paymentCode}).subscribe(response => {
      this.paymentProcessEnded = true;

      if(response) {
        if (response.state === 'PAID') {
          // successful payment
          this.paymentSuccessful = true;
          sessionStorage.clear();
        } else {
          this.paymentSuccessful = false;
        }
      } else {
        this.LoadscreenService.cancelLoading();
        this.paymentProcessEnded = false;
        this.ToastService.initializeMessage('Critical error: getInsuredPersonFromHipQuery method response was empty!', 'error');
      }

      this.insuredPerson = response;
      this.LoadscreenService.cancelLoading();
    }, error => {
      this.paymentProcessEnded = true;

      this.LoadscreenService.cancelLoading();
      this.ToastService.initializeMessage(error.message, 'error');
    });
  }

  restartPayment() {
    this.api.payInsuredPersonFromHip({insuredPersonFromHIPId: this.insuredPerson.id}).subscribe(response => {
      this.LoadscreenService.cancelLoading();
      window.location.href = response['response'];
    }, error => {
      this.LoadscreenService.cancelLoading();
      this.ToastService.initializeMessage(error.error.validationErrors[0].errorMessage, 'error');
    });
  }
}
